import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxConfirmInformationIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M16.9784 11.8304C16.728 11.8304 16.5248 12.0336 16.5248 12.284V16.4184C16.5248 18.1696 15.1 19.5952 13.348 19.5952H6.80159C5.05039 19.5952 3.62479 18.1704 3.62479 16.4184V9.8904C3.62479 8.1392 5.04959 6.7136 6.80159 6.7136H13.5248C13.7752 6.7136 13.9784 6.5104 13.9784 6.26C13.9784 6.0096 13.7752 5.8064 13.5248 5.8064H6.80159C4.54959 5.8064 2.71759 7.6384 2.71759 9.8904V16.4184C2.71759 18.6704 4.54959 20.5024 6.80159 20.5024H13.348C15.6 20.5024 17.432 18.6704 17.432 16.4184V12.284C17.432 12.0336 17.2288 11.8304 16.9784 11.8304Z"
            fill="#222"
          />
          <path
            d="M14.952 7.5056C14.872 7.5856 14.828 7.692 14.828 7.8056V9.6808C14.828 9.9144 15.0184 10.1048 15.252 10.1048H16.808C16.9216 10.1048 17.028 10.0608 17.108 9.9808L21.1752 5.928C21.2552 5.848 21.3008 5.7368 21.2992 5.6232 21.2976 5.5096 21.2496 5.4 21.1672 5.3216L19.4096 3.648C19.3272 3.5696 19.2216 3.5304 19.1168 3.5304 19.012 3.5304 18.9 3.572 18.8168 3.656L14.9512 7.5072 14.952 7.5056zM19.1248 4.5472L20.268 5.6352 16.632 9.256H15.676V7.9808L15.6848 7.972 19.1248 4.5472zM12.4656 10.9776C12.4536 10.9888 11.2792 12.1168 10.524 12.852 10.0496 13.3136 9.43439 13.952 9.02159 14.384L7.71279 12.8808C7.53759 12.6792 7.23119 12.6584 7.02959 12.8336 6.82799 13.0088 6.80719 13.3152 6.98239 13.5168L8.46399 15.2184C8.59839 15.3728 8.79279 15.464 8.99759 15.468 9.00319 15.468 9.00799 15.468 9.01359 15.468 9.21279 15.468 9.40479 15.3856 9.54239 15.2408 9.92959 14.8328 10.6608 14.0696 11.1992 13.5448 11.952 12.812 13.124 11.6864 13.1352 11.6752 13.328 11.4904 13.3344 11.184 13.1488 10.9904 12.964 10.7976 12.6576 10.7912 12.4648 10.9768L12.4656 10.9776z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
